import styled from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 0 0.5rem;
`;

export default ContentWrapper;
